<template>
  <div
    ref="warning-info-telemed"
    class="pa-4 warning-info"
    :class="{ 'warning-info_error': isErrorWarningInfo }"
  >
    <v-expand-transition>
      <div
        v-if="isErrorWarningInfo"
        class="text-body-2 text-error--text"
      >
        <div class="mb-4">
          {{ $t('Отметьте, что принимаете условие', options) }}
        </div>
      </div>
    </v-expand-transition>
    <div class="d-flex align-center">
      <div class="mr-4 text-body-1 text--text">
        <!-- eslint-disable max-len -->
        {{ $t('Принимаю правило онлайн консультации: врач не выпишет рецепт и заключение, он даст только рекомендации', options) }}
      </div>
      <v-switch
        color="primary"
        class="pt-0 mt-0 pl-1 mr-n4"
        data-qa="warning_info_telemed_switch_input"
        hide-details
        dense
        inset
        @change="handleChangeReadWarningInfo"
        @click.stop
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useUserDataStore } from 'www/vue_components/common/AppointmentPage/stores'

export default {
  name: 'AppointmentWarningInfoTelemed',
  data: vm => ({
    options: { ns: vm.$i18next.language },
  }),
  computed: {
    ...mapState(useUserDataStore, [
      'isErrorWarningInfo',
      'isReadWarningInfo',
    ]),
  },
  mounted() {
    this.updateWarningInfoTelemedEl(this.$refs['warning-info-telemed'])
  },
  methods: {
    ...mapActions(useUserDataStore, [
      'updateIsReadWarningInfo',
      'updateIsErrorWarningInfo',
      'updateWarningInfoTelemedEl',
    ]),
    handleChangeReadWarningInfo(newValue) {
      this.updateIsReadWarningInfo(newValue)
      this.updateIsErrorWarningInfo(!newValue)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.warning-info {
  border-radius: $border-radius-sm;
  background-color: $ui-kit-bg-secondary;
  border: 1px solid transparent;

  &_error {
    border: 1px solid $ui-kit-error;
  }
}
</style>
